import * as React from "react";
import { Dialog } from "@/components/ui";
import { SocoAiLogo } from "@/components/Holo";

interface PersonalizedPostsHelpDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

const STEPS = [
  "Your marketing team creates pre-approved, on-brand designs.",
  "You pick a review. We add your name, photo, and branding.",
  "Check the caption, choose where to post, and you're done.",
];

export const PersonalizedPostsHelpDialog: React.FC<PersonalizedPostsHelpDialogProps> = ({ open, onOpenChange }) => (
  <Dialog open={open} onOpenChange={onOpenChange} size="xl" showCloseButton>
    <Dialog.Header>
      <Dialog.Title className="flex items-center gap-2 text-xl font-bold">
        <SocoAiLogo variant="mono" height={16} />
        <span>How personalized posts work</span>
      </Dialog.Title>
    </Dialog.Header>
    <Dialog.Content className="max-h-[70vh] overflow-y-auto py-4">
      <ol className="grid grid-cols-1 gap-4 md:grid-cols-3">
        {STEPS.map((text, i) => (
          <li
            key={i}
            className="flex flex-col gap-2 rounded-xl border border-slate-200/50 bg-slate-50 p-4 text-sm leading-normal text-slate-600"
          >
            <span className="flex size-7 items-center justify-center rounded-full bg-indigo-100 text-sm font-semibold text-primary">
              {i + 1}
            </span>
            <p>{text}</p>
          </li>
        ))}
      </ol>
    </Dialog.Content>
  </Dialog>
);
